import { createAction } from 'redux-act';

export const createTrackingLog = createAction();
export const createUsageLog = createAction();
export const createUsageTrackingEvent = createAction();
export const trackingIdLoaded = createAction();
